<template>
  <div>
    <v-card outlined class="app-card">
      <v-card-title class="app-card-title">
        Transportadora
        <v-btn
          depressed
          small
          color="error"
          v-on:click="logout()"
          class="btn-logout"
        >
          <v-icon>exit_to_app</v-icon>Sair
        </v-btn></v-card-title
      >
      <v-card-text class="app-card-content">
        <v-row no-gutters v-if="transportadora">
          <v-col :md="12" :sm="12" :xs="12" cols="12">
            <strong class="info-text">
              Razão Social:
              <em>{{ transportadora.razaosocial }}</em>
            </strong>
          </v-col>
          <v-col :md="12" :sm="12" :xs="12" cols="12" class="mt-2 text-md-left">
            <strong class="info-text">
              CNPJ:
              <em>{{ transportadora.cnpj | cnpj }}</em>
            </strong>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <ConsultaForm :transportadora="transportadora" v-if="transportadora" />
  </div>
</template>

<script>
import ConsultaForm from "./ConsultaForm";
import TransportadoraAuthService from "@/services/transportadora.auth.service";

export default {
  components: {
    ConsultaForm
  },
  data() {
    return {
      transportadora: null
    };
  },
  methods: {
    getCurrentTransportadora() {
      this.transportadora =
        TransportadoraAuthService.currentTransportadoraValue;
    },
    logout() {
      TransportadoraAuthService.logout();
    }
  },
  mounted() {
    this.getCurrentTransportadora();
  }
};
</script>
